import { z } from 'zod';

import { RateSource } from '@/modules/common/types/rate-source';

export const externalRatesSchema = z.object({
  defaultCurrencyCode: z
    .string()
    .min(1, 'authenticated.settings:pages.finance.validation.currencyRequired'),
  defaultProjectRateSource: z.nativeEnum(RateSource, {
    errorMap: () => ({
      message: 'authenticated.settings:pages.finance.validation.rateSourceRequired',
    }),
  }),
  defaultRate: z
    .number({
      invalid_type_error: 'authenticated.settings:pages.finance.validation.rateInvalid',
    })
    .min(0, 'authenticated.settings:pages.finance.validation.ratePositive'),
});

export type ExternalRatesFormValues = z.infer<typeof externalRatesSchema>;
